import { render, staticRenderFns } from "./RecruiterDashboard.vue?vue&type=template&id=c0b0fcc6&scoped=true"
import script from "./RecruiterDashboard.vue?vue&type=script&lang=ts"
export * from "./RecruiterDashboard.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterDashboard.vue?vue&type=style&index=0&id=c0b0fcc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b0fcc6",
  null
  
)

export default component.exports